export default __webpack_public_path__ + "static/4th-of-july-summer-steals-banner-mobile-9af178c961b819b4771a78cedc41b5e7.webp";